// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Conference from './pages/Conference';
import Caravan from './pages/Caravan';
import Stands from './pages/Stands';
import Videos from './pages/Videos';
import Spectacle from './pages/Spectacle';
import Chiffres from './pages/Chiffres';


import HomeAMZ from './pages/HomeAMZ';
import CaravanAMZ from './pages/CaravanAMZ';
import AboutAMZ from './pages/AboutAMZ';
import ConferenceAMZ from './pages/ConferenceAMZ';
import VideosAMZ from './pages/VideosAMZ';
import SpectacleAMZ from './pages/SpectacleAMZ';
import StandsAMZ from './pages/StandsAMZ';
import ChiffresAMZ from './pages/ChiffresAMZ';


import HomeENG from './pages/HomeENG';
import AboutENG from './pages/AboutENG';
import ConferenceENG from './pages/ConferenceENG';
import VideosENG from './pages/VideosENG';
import StandsENG from './pages/StandsENG';
import CaravanENG from './pages/CaravanENG';
import SpectacleENG from './pages/SpectacleENG';
import ChiffresENG from './pages/ChiffresENG';

import './styles/global.css';
import './styles/direction.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            {/* Routes par défaut (arabe) */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/conference" element={<Conference />} />
            <Route path="/caravan" element={<Caravan />} />
            <Route path="/stands" element={<Stands />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/chiffres" element={<Chiffres />} />
            <Route path="/spectacle" element={<Spectacle />} />

            {/* Routes en anglais */}
            <Route path="/en" element={<HomeENG />} />
            <Route path="/en/about" element={<AboutENG />} />
            <Route path="/en/conference" element={<ConferenceENG />} />
            <Route path="/en/caravan" element={<CaravanENG />} />
            <Route path="/en/stands" element={<StandsENG />} />
            <Route path="/en/videos" element={<VideosENG />} />
            <Route path="/en/chiffres" element={<ChiffresENG />} />
            <Route path="/en/spectacle" element={<SpectacleENG />} />

            {/* Routes en amazigh */}
            <Route path="/amz" element={<HomeAMZ />} />
            <Route path="/amz/about" element={<AboutAMZ />} />
            <Route path="/amz/conference" element={<ConferenceAMZ />} />
            <Route path="/amz/caravan" element={<CaravanAMZ />} />
            <Route path="/amz/stands" element={<StandsAMZ />} />
            <Route path="/amz/videos" element={<VideosAMZ />} />
            <Route path="/amz/chiffres" element={<ChiffresAMZ />} />
            <Route path="/amz/spectacle" element={<SpectacleAMZ />} />

            {/* Redirect pour les routes non trouvées */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
